module.exports = __webpack_public_path__ + "img/icon3.293d4237.png";